import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder} from '@angular/forms';
import {Race} from '../shared/classes/Race';

export class Header {
  defName: string;
  translation: string;
  elem: string;
}

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css']
})
export class SearchInputComponent implements OnInit {

  default: Header = {
    defName: 'all',
    translation: 'searchInput.all',
    elem: 'all'
  };

  // searchList: Header[] = [{
  //   defName: 'all',
  //   translation: 'searchInput.all',
  //   elem: 'all'
  // }];

  searchList: Header[] = [];
  timeSelect = 'all';

  @Input()
  data;

  @Input()
  selectedDefault = 'all';

  @Input()
  addAllParam = false;

  @Input()
  searchBy: Header[] = [];

  @Input()
  timeSearchVisible: false;

  @Output()
  filteredData = new EventEmitter() ;

  searchForm = this.formBuilder.group({
    search: ['', []],
    filter: [this.selectedDefault, []]
  });

  constructor( private formBuilder: FormBuilder) { }

  ngOnInit() {
    if (this.addAllParam) {
      this.searchList.push(this.default);
    }
    this.searchList = this.searchList.concat(this.searchBy);
    this.searchForm.patchValue({filter: this.default.defName});
  }

  createItem(name) {
    return this.formBuilder.group({
        name: ['', [] ]
    });
  }

  createFilter() {
    const list = [];
    this.searchBy.forEach( item => {
      list.push((this.searchForm.controls.filter as FormArray).push(this.createItem(item)));
    });
    return list;
  }

  addIfNotExist(filtered: any[], data: any[]): any[] {
    data.forEach(d => {
      if (filtered.filter(i => i === d).length > 0) {

      } else {
        filtered.push(d);
      }
    });
    return filtered;
}
  compareRace(race: Race, now){
    const date = race.dateStart.split('.');
    const raceDate = new Date(date[2], date[1], date[0]);
    return raceDate >= now;
  }

  selectRace(select) {
    this.timeSelect = select;
  }

  timePreFilter() {
    let filtered = [];
    const now = new Date();
    now.setHours(0,0,0,0);
    switch (this.timeSelect) {
      case 'all':
        filtered = this.data;
        break;
      case 'future':
        filtered = this.data.filter(race => this.compareRace(race, now));
        break;
      case 'last':
        filtered = this.data.filter(race => !this.compareRace(race, now));
        break;
    }
    return filtered;
  }

  searchInData() {
    let localData = this.data;
    if (this.timeSearchVisible){
      localData = this.timePreFilter();
    }
    const search = this.searchForm.get('search').value;
    let searchBy = this.searchForm.get('filter').value;
    let filtered = [];

    if (search === '' || searchBy === undefined) {
      filtered = localData;
    } else {
      if (searchBy !== this.default.defName) {
        filtered = localData.filter(item => eval(`item.${searchBy}`).toLowerCase() === search.toLowerCase() || eval(`item.${searchBy}`).toLowerCase().includes(search.toLowerCase()));
      } else {
        this.searchList.filter(a => a.defName !== 'all').forEach(key => {
          filtered = filtered.concat(localData.filter(item => eval(`item.${key.defName}`).toLowerCase() === search.toLowerCase() || eval(`item.${key.defName}`).toLowerCase().includes(search.toLowerCase())));
        });
        filtered = [...new Set(filtered)];
      }
    }
    this.filteredData.emit(filtered);
  }

}
